interface AdminErrorProps {
  error: unknown
  title?: string
}

function messageOf(error: unknown): string {
  if (!error) return ''
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  const maybe = error as { message?: string }
  return maybe.message ?? 'Unknown error'
}

/**
 * Admin gating is enforced by RLS, not by AdminGuard — a non-admin session gets
 * a permission error here rather than an empty dashboard. Show it verbatim.
 */
export function AdminError({ error, title }: AdminErrorProps) {
  if (!error) return null
  const message = messageOf(error)
  const denied = /permission denied|row-level security|violates|not authorized|JWT/i.test(message)

  return (
    <div className="admin-alert admin-alert--error" role="alert">
      <strong className="admin-alert__title">{title ?? (denied ? 'Permission denied' : 'Something went wrong')}</strong>
      <span className="admin-alert__body">{message}</span>
      {denied && (
        <span className="admin-alert__hint">
          This account does not have super-admin access in the database.
        </span>
      )}
    </div>
  )
}
